<template>
  <div class="wrapper">
    <navbar v-if="isMobile()"></navbar>
    <div class="main-panel">
    
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
@import "../../../assets/sass/paper/_variables.scss";
:root {
  --required : '*'
}
.main-panel {
  background-color: white !important;
}
.main-panel .required:after {
  content: var(--required) !important;
  color: $danger-color !important;
}
</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import axios from 'axios'
  import Navbar from './Navbar.vue'
  import {ValidationUtils} from '../../../utils/Validation'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      Navbar
    },
    mixins: [ValidationUtils],
    data () {
      return {
        requiredConfig: this.$store.state.configs['REQUIREMENT_FIELD'] || '',
        token: localStorage.getItem('token')
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      translateFields () {
        axios({
          url: process.env.SERVER_URI + '/translation',
          method: 'get'
        })
        .then((response) => {
          this.$store.state.translation = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    async beforeMount () {
      await this.translateFields()
      if (this.$route.query.lang !== undefined) {
        this.$store.state.lang.value = this.$route.query.lang
      }
    },
    mounted () {
      if (this.requiredConfig !== '') {
        document.body.style.setProperty('--required', '"' + this.requiredConfig + '"')
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue